import { Row, Col, Typography, Divider, Tag, Card } from "antd";
import React from "react";
import {
  FaMapMarkerAlt,
  FaBriefcase,
  FaMoneyBillWave,
  FaGraduationCap,
  FaUser,
  FaClock,
} from "react-icons/fa";

const { Text } = Typography;

const JobDetails = ({
  keywords,
  requiredQualification,
  jobDescription,
  options,
  experience,
  address,

  wageType,
  wagePeriod,
  minEducationLevel,
  minAge,
  maxAge,
  wageAmount,
  currency,
}) => {
  const getGroupedOptions = (options) => {
    const grouped = {};
    options?.forEach((category) => {
      const selectedOpts = category.options.filter((opt) => opt.isSelected);
      if (selectedOpts.length > 0) {
        grouped[category.name] = {
          categoryName: category.name,
          options: selectedOpts,
        };
      }
    });
    return grouped;
  };

  const groupedOptions = getGroupedOptions(options);

  const renderDetailCard = (Icon, title, value) => (
    <Card size="small" style={{ height: "100%" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: "4px",
        }}>
        <Icon size={16} style={{ color: "#1890ff" }} />
        <Text strong style={{ color: "#666" }}>
          {title}
        </Text>
      </div>
      <Text style={{ color: "#333" }}>{value}</Text>
    </Card>
  );

  const formatAge = () => {
    if (minAge && maxAge) {
      return `${minAge} - ${maxAge} yaş arası`;
    }
    if (minAge) {
      return `${minAge} yaş ve üzeri`;
    }
    if (maxAge) {
      return `${maxAge} yaş ve altı`;
    }
    return null;
  };

  return (
    <>
      <div style={{ marginTop: "30px" }}>
        <Divider orientation="left" style={{ fontWeight: "bold" }}>
          İşin Tanımı
        </Divider>
        <Typography.Paragraph style={{ textAlign: "start" }}>
          {jobDescription}
        </Typography.Paragraph>
      </div>

      <div style={{ marginTop: "30px" }}>
        <Divider orientation="left" style={{ fontWeight: "bold" }}>
          Aranan Nitelikler
        </Divider>
        <Typography.Paragraph style={{ textAlign: "start" }}>
          {requiredQualification}
        </Typography.Paragraph>
      </div>

      <div style={{ marginTop: "30px" }}>
        <Divider orientation="left" style={{ fontWeight: "bold" }}>
          Pozisyon Detayları
        </Divider>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={8}>
            {renderDetailCard(FaMapMarkerAlt, "Lokasyon", address)}
          </Col>
          <Col xs={24} md={8}>
            {renderDetailCard(FaBriefcase, "Deneyim", `${experience}`)}
          </Col>
          <Col xs={24} md={8}>
            {renderDetailCard(
              FaMoneyBillWave,
              "Ücret",
              `${wageAmount} ${currency} - ${wagePeriod}  ${wageType}`
            )}
          </Col>
          {minEducationLevel && (
            <Col xs={24} md={8}>
              {renderDetailCard(
                FaGraduationCap,
                "Minimum Eğitim",
                minEducationLevel
              )}
            </Col>
          )}
          {formatAge() && (
            <Col xs={24} md={8}>
              {renderDetailCard(FaUser, "Yaş Aralığı", formatAge())}
            </Col>
          )}
        </Row>
      </div>

      <div style={{ marginTop: "30px" }}>
        <Divider orientation="left" style={{ fontWeight: "bold" }}>
          İş Gereksinimleri
        </Divider>
        <Row gutter={[16, 16]}>
          {Object.values(groupedOptions).map((category, index) => (
            <Col md={12} xs={24} key={index}>
              <div
                style={{
                  background: "#f5f5f5",
                  padding: "16px",
                  borderRadius: "6px",
                  marginBottom: "12px",
                  height: "100%",
                }}>
                <Text strong style={{ color: "#666", fontSize: "14px" }}>
                  {category.categoryName}:
                </Text>
                <div
                  style={{
                    marginTop: "8px",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "8px",
                  }}>
                  {category.options.map((option, optIndex) => (
                    <Tag
                      key={optIndex}
                      color="blue"
                      style={{
                        padding: "4px 12px",
                        marginRight: 0,
                        fontSize: "13px",
                      }}>
                      {option.name}
                    </Tag>
                  ))}
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>

      <div style={{ marginTop: "30px" }}>
        {keywords.length !== 0 && (
          <Divider orientation="left" style={{ fontWeight: "bold" }}>
            Yetenekler
          </Divider>
        )}
        <Row gutter={[8, 8]}>
          {keywords?.map((skill, index) => (
            <Col key={index}>
              <Tag
                style={{
                  height: 30,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "0 12px",
                }}
                color="blue">
                {skill}
              </Tag>
            </Col>
          ))}
        </Row>
      </div>
    </>
  );
};

export default JobDetails;
